/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var _ = require('underscore');
var moment = require('moment');

var UIUtil = require('psa-core/util/ui');
var parsleyUtil = require('common/util/parsleyUtil');

var FileUploadCollection = require('psa-backbone/models/FileUploadCollection');

var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var toggleForm = require('common/util/toggleForm');
var makeFormReadOnly = require('common/util/makeFormReadOnly');

var ButtonCell = require('common/backgrid/ButtonCell');

var COCAddPresenterModalView = require('./COCAddPresenterModalView');

var tmplCOCEventDetailsView = require('../templates/COCEventDetailsView.hbs');
var COCSelectRowCell = require('../../common/backgrid/COCSelectRowCell');
var Syphon = require('backbone.syphon');
var modelGet = require('common/util/modelGet');
var EventFileUploadView = require('common/views/FileUploadView/EventFileUploadView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEventDetailsView,

  className: 'coc-event-details-view form-horizontal',

  ui: {
    eventDetailsForm: '.event-details-form',
    eventInformationSection: '.event-information',
    eventAttachmentsField: '.event-attachments-field',
    eventAttachments: '.event-attachments-container',
    presentationInformation: '.presentation-information',
    presenterContainer: '.presenter-container',
    presentersTable: '.presenters-table',
    presentersTableErrors: '#presentersTableErrors',
    dateTimeErrors: '#dateTimeErrors',
    addPresenter: '.add-presenter',
    startDate: '.start-date',
    endDate: '.end-date',
    registrationRequired: '[name="isRegistrationRequired"]',
    registrationDetails: '.registration-details',
    registrationDetailsInput: '.registration-details-input',
    isAARPEvent: '[name="isAARPEvent"]',
    AARPVolunteers: '[name="AARPVolunteers"]'
  },

  regions: {
    eventAttachments: '@ui.eventAttachments',
    presentersTable: '@ui.presentersTable'
  },

  events: {
    'click @ui.addPresenter': 'onClickAddPresenter',
    'change @ui.registrationRequired': 'onChangeRegistrationRequired',
    'change @ui.isAARPEvent': 'onChangeIsAARPEvent'
  },

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  onBeforeShow: function() {
    this.ui.startDate.datepicker();
    this.ui.endDate.datepicker();
    var event = this.model.get('event') || {};
    var isTaskView = this.model.get('isTaskView');
    var view = this.model.get('view');

    var presenters = this.model.get('presenters') || [];

    var eventDocuments = _.pluck(modelGet(this.model, 'event.eventDocuments', []), 'file');

    this.eventAttachments = new EventFileUploadView({
      isReadOnly: this.options.isReadOnly,
      allowMultipleFiles: true,
      isRequired: false,
      collection: new FileUploadCollection(eventDocuments),
      metadata: {
        documentTypeId: 60001
      }
    });
    this.showChildView('eventAttachments', this.eventAttachments);

    var presentersGridColumns = [
      {
        name: 'name',
        label: 'Name',
        cell: 'string',
        headerCell: 'custom',
        width: 30,
        editable: false
      },
      {
        name: 'username',
        label: 'Username',
        cell: 'string',
        headerCell: 'custom',
        width: 25,
        editable: false
      },
      {
        name: 'eventFollowUpTaskOwner',
        label: 'Follow Up Owner',
        cell: COCSelectRowCell.SelectRowCell,
        headerCell: 'custom',
        width: 25,
        editable: true,
        sortable: false,
        singleSelect: true
      },
      {
        name: '',
        label: '',
        cell: ButtonCell.extend({
          name: 'Delete',
          buttonClass: 'btn-primary m-t-xs',
          onClick: this.onClickDeletePresenter.bind(this)
        }),
        headerCell: 'custom',
        width: 20,
        editable: false
      }
    ];

    this.presentersGridView = new GridView({
      columns: presentersGridColumns,
      collection: new PageableCollection(this.collection, { pageSize: 10 }),
      emptyText: 'No Presenters Added.'
    });

    this.showChildView('presentersTable', this.presentersGridView);

    if (presenters.length > 0) {
      this.presentersGridView.collection.add(presenters);
    }

    Syphon.deserialize(this, event);
    if (isTaskView) {
      toggleForm(this.ui.presentationInformation, false);
      toggleForm(this.ui.eventAttachmentsField, false);
      makeFormReadOnly(this.ui.eventInformationSection);
      makeFormReadOnly(this.ui.registrationDetails);
      this.ui.registrationRequired.prop('disabled', 'true');
    }
    if (view === 'edit') {
      toggleForm(this.ui.presentationInformation, false);
      toggleForm(this.ui.eventAttachmentsField, false);
      this.ui.isAARPEvent.removeAttr('data-parsley-required');
    }
  },

  onShow: function() {
    var registrationRequiredVal = this.ui.registrationRequired.val();
    var isTaskView = this.model.get('isTaskView');
    var view = this.model.get('view');

    if (registrationRequiredVal === '0' || !registrationRequiredVal || registrationRequiredVal === '') {
      this.ui.registrationDetails.hide();
    } else {
      this.ui.registrationDetails.show();
    }

    var isAARPEventVal = this.ui.isAARPEvent.val();

    if (!isAARPEventVal || isAARPEventVal === '') {
      this.ui.presenterContainer.hide();
      this.ui.addPresenter.prop('disabled', true);
    } else if (isAARPEventVal === '1') {
      this.ui.presenterContainer.hide();
    } else {
      this.ui.presenterContainer.show();
    }

    if (isTaskView || view === 'edit') {
      this.ui.addPresenter.prop('disabled', true);
    }
  },

  onClickAddPresenter: function(e) {
    e.preventDefault();
    var self = this;
    var addedPresenters = this.presentersGridView.collection.fullCollection.models;
    var hasFollowUpOwner = _.some(addedPresenters, function(presenter) {
      return presenter.get('eventFollowUpTaskOwner') === true;
    });

    var presenterUsernameArray = _.map(self.presentersGridView.collection.fullCollection.models, function(user) {
      return user.get('username');
    });

    UIUtil.showModal({
      title: 'Add Presenter',
      view: new COCAddPresenterModalView({
        model: new Backbone.Model({
          cocUsers: self.model.get('cocUsers'),
          hasFollowUpOwner: hasFollowUpOwner,
          existingPresenters: presenterUsernameArray
        })
      })
    }).done(function(presenter) {
      self.presentersGridView.collection.add(presenter);
    });
  },

  onClickDeletePresenter: function(e, model) {
    e.preventDefault();
    this.presentersGridView.collection.remove(model);
  },

  onChangeRegistrationRequired: function() {
    var registrationRequiredVal = this.ui.registrationRequired.val();

    if (registrationRequiredVal === '0' || !registrationRequiredVal) {
      this.ui.registrationDetails.hide();
      this.ui.registrationDetailsInput.parsley().reset();
    } else {
      this.ui.registrationDetails.show();
      this.ui.registrationDetailsInput.parsley().reset();
    }
  },

  onChangeIsAARPEvent: function() {
    var isAARPEventVal = this.ui.isAARPEvent.val();
    var isTaskView = this.model.get('isTaskView');
    var view = this.model.get('view');

    if (!isAARPEventVal || isAARPEventVal === '') {
      this.ui.presenterContainer.hide();
      this.ui.addPresenter.prop('disabled', true);
    } else if (isAARPEventVal === '1') {
      this.ui.presenterContainer.hide();
      this.ui.addPresenter.prop('disabled', true);
    } else {
      this.ui.presenterContainer.show();
      this.ui.addPresenter.prop('disabled', false);
    }
    if (isTaskView || view === 'edit') {
      this.ui.addPresenter.prop('disabled', true);
    }
  },

  validate: function(config) {
    this.ui.eventDetailsForm.parsley().reset();
    var isTaskView = this.model.get('isTaskView');
    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.eventDetailsForm);
    } else {
      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.eventDetailsForm);
    }

    var validationPromises = [this.ui.eventDetailsForm.parsley().whenValidate()];

    if (this.ui.isAARPEvent.val() === '0' && this.model.get('view') !== 'edit') {
      validationPromises.push(this.validatePresenters(this.presentersGridView.collection.fullCollection.models));
    }
    if (!isTaskView) {
      validationPromises.push(this.validateDates());
    }
    return $.when.apply($, validationPromises);
  },

  validateDates: function() {
    var defer = $.Deferred();
    this.ui.dateTimeErrors.hide();
    var formData = Syphon.serialize(this);

    var startDateTime = moment(formData.startDate + ' ' + formData.startTime, 'MM/DD/YYYY HH:mm');

    var endDateTime = moment(formData.endDate + ' ' + formData.endTime, 'MM/DD/YYYY HH:mm');

    if (startDateTime.isBefore(endDateTime)) {
      this.ui.dateTimeErrors.hide();
      defer.resolve();
    } else {
      this.ui.dateTimeErrors.show();
      defer.reject();
    }

    return defer.promise();
  },

  validatePresenters: function(addedPresenters) {
    var defer = $.Deferred();
    this.ui.presentersTableErrors.hide();

    var hasAtLeastOnePresenter = addedPresenters.length > 0;
    var hasExactlyOneFollowUpOwner =
      _.filter(addedPresenters, function(presenter) {
        return presenter.get('eventFollowUpTaskOwner') === true;
      }).length === 1;

    if (hasAtLeastOnePresenter && hasExactlyOneFollowUpOwner) {
      this.ui.presentersTableErrors.hide();
      defer.resolve();
    } else {
      this.ui.presentersTableErrors.show();
      defer.reject();
    }

    return defer.resolve();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    var isTaskView = this.model.get('isTaskView');
    if (!isTaskView) {
      if (formData.isAARPEvent === '0') {
        var presentersCollection = this.presentersGridView.collection.fullCollection.models;

        formData.presenters = [];
        _.each(presentersCollection, function(presenter) {
          var presenterObject = {
            name: presenter.get('name'),
            isTaskOwner: presenter.get('eventFollowUpTaskOwner') === true ? 1 : 0,
            username: presenter.get('username'),
            userId: presenter.get('userId'),
            email: presenter.get('email')
          };

          formData.presenters.push(presenterObject);
        });
      }
      formData.eventDocuments = this.eventAttachments.collection.map(function(file) {
        return {
          fileId: file.get('fileId'),
          documentTypeId: modelGet(file, 'metadata.documentTypeId')
        };
      });
    }
    return formData;
  }
});
